import { createSlice } from "@reduxjs/toolkit";

import { get, patch, post } from "../../helpers/axios";
import {
  GET_STATE_ADMIN_LIST,
  PATCH_ACTIVATE_STATE_ADMIN,
  PATCH_DELETE_STATE_ADMIN,
  PATCH_RESET_EMPLOYEE_PASSWORD,
  PATCH_RESET_STATE_ADMIN_PASSWORD,
  POST_CREATE_STATE_ADMIN,
} from "../../helpers/url_helpers";

const initialState = {
  loading: false,
  stateAdminListError: "",
  newStateAdminError: "",
  stateAdminList: [],
  createStateAdminLoading: false,
  activateStateAdminLoading: false,
};

const stateAdminManagement = createSlice({
  name: "stateAdminManagement",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload.loading;
    },
    setStateAdminList: (state, action) => {
      state.stateAdminList = action.payload.stateAdminList;
    },
    setListingError: (state, action) => {
      state.stateAdminListError = action.payload.stateAdminListError;
    },
    setNewStateAdminError: (state, action) => {
      state.newStateAdminError = action.payload.newStateAdminError;
    },
    setCreateStateAdminLoading: (state, action) => {
      state.createStateAdminLoading = action.payload;
    },
    setActivateStateAdminLoading: (state, action) => {
      state.activateStateAdminLoading = action.payload.loading;
    },

    setActivateStateAdmin: (state, action) => {
      state.stateAdminList.state_admin_data =
        state.stateAdminList.state_admin_data.map((admin) =>
          admin.email === action.payload.email
            ? { ...admin, is_active: action.payload.is_active }
            : admin
        );
    },

    reset: (state, action) => {
      if (action.payload?.isListWithSearch) state.stateAdminList = [];
      state.loading = false;
      state.stateAdminListError = "";
      state.newStateAdminError = "";
      state.createStateAdminLoading = false;
    },
  },
});

export const {
  setLoading,
  setStateAdminList,
  setListingError,
  setNewStateAdminError,
  reset,
  setCreateStateAdminLoading,
  setActivateStateAdminLoading,
  setActivateStateAdmin,
} = stateAdminManagement.actions;
export default stateAdminManagement.reducer;

export const getStateAdminList =
  (searchItem = "", pageNumber = 1, pageSize = "") =>
  async (dispatch) => {
    let response;
    try {
      dispatch(setListingError({ stateAdminListError: "" }));
      dispatch(setLoading({ loading: true }));
      dispatch(
        setStateAdminList({
          stateAdminList: [],
        })
      );
      // api call
      response = await get(
        GET_STATE_ADMIN_LIST.replace("{searchItem}", searchItem)
          .replace("{pageNumber}", pageNumber)
          .replace("{pageSize}", pageSize)
      );

      if (response) {
        if (response.error) {
          dispatch(
            setListingError({
              stateAdminListError: response?.error?.detail,
            })
          );
        } else {
          dispatch(
            setStateAdminList({
              stateAdminList: response?.data,
            })
          );
        }
      }
      dispatch(setLoading({ loading: false }));
    } catch (error) {
      if (error)
        dispatch(
          setListingError({
            stateAdminListError: error,
          })
        );
      dispatch(setLoading({ loading: false }));
    }
  };

export const activateStateAdmin = (payload, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setActivateStateAdminLoading({ loading: true }));
    dispatch(setListingError({ stateAdminListError: "" }));

    // api call
    response = await patch(PATCH_ACTIVATE_STATE_ADMIN, payload);

    if (response) {
      dispatch(setActivateStateAdminLoading({ loading: false }));
      if (response.error) {
        dispatch(
          setListingError({
            stateAdminListError: response?.error?.detail,
          })
        );
      } else {
        dispatch(setActivateStateAdmin(payload));
      }
    }
    // if (callback) callback();
  } catch (error) {
    dispatch(setActivateStateAdminLoading({ loading: false }));
    if (error)
      dispatch(
        setListingError({
          stateAdminListError: error,
        })
      );
  }
};

export const createStateAdmin = (payload, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setCreateStateAdminLoading(true));
    dispatch(setNewStateAdminError({ newStateAdminError: "" }));
    // api call
    response = await post(POST_CREATE_STATE_ADMIN, payload);
    if (response) {
      dispatch(setCreateStateAdminLoading(false));
      if (response.error) {
        dispatch(
          setNewStateAdminError({
            newStateAdminError: response?.error,
          })
        );
      } else {
        if (callback) callback(response?.data);
      }
    }
  } catch (error) {
    dispatch(setCreateStateAdminLoading(false));
    if (error)
      dispatch(
        setNewStateAdminError({
          newStateAdminError: error,
        })
      );
  }
};

export const editStateAdmin =
  (payload, isStateDotAdmin, callback) => async (dispatch) => {
    let response;
    try {
      dispatch(setNewStateAdminError({ newStateAdminError: "" }));

      // api call
      response = await patch(POST_CREATE_STATE_ADMIN, payload);

      if (response) {
        if (response.error) {
          dispatch(
            setNewStateAdminError({
              newStateAdminError: response?.error?.detail,
            })
          );
          if (callback) callback("failure");
        } else {
          if (callback) callback("success");
        }
      }
    } catch (error) {
      if (error)
        dispatch(
          setNewStateAdminError({
            newStateAdminError: error,
          })
        );
    }
  };

export const deleteStateAdmin = (payload, callback) => async (dispatch) => {
  let response;
  try {
    dispatch(setListingError({ stateAdminListError: "" }));
    // api call
    response = await patch(PATCH_DELETE_STATE_ADMIN, payload);

    if (response) {
      if (response.error) {
        dispatch(
          setListingError({
            stateAdminListError: response?.error?.detail,
          })
        );
      } else if (callback) callback(response?.message);
    }
  } catch (error) {
    if (error)
      dispatch(
        setListingError({
          stateAdminListError: error,
        })
      );
  }
};

export const clearNewStateAdminError = () => async (dispatch) => {
  dispatch(setNewStateAdminError({ newStateAdminError: "" }));
};

export const resetStateAdminPassword =
  (payload, callback) => async (dispatch) => {
    let response;
    try {
      dispatch(setListingError({ stateAdminListError: "" }));
      // api call
      response = await patch(PATCH_RESET_EMPLOYEE_PASSWORD, payload);

      if (response) {
        if (response.error) {
          dispatch(
            setListingError({
              stateAdminListError: response?.error?.detail,
            })
          );
        } else if (callback) callback(response?.message);
      }
    } catch (error) {
      if (error)
        dispatch(
          setListingError({
            stateAdminListError: error,
          })
        );
    }
  };
